import { createSelector } from 'reselect';

import { getCurrentUserIsReadOnly } from 'modules/users/selectors/currentUser';

import { CONTACT_LIST_STATUS_ENUM } from '../constants';

/** @return {import('modules/contactLists/reducers').ContactListReducer} */
const getState = state => state.contactLists;

export const getRoot = state => state;
export const getProps = (_, props) => props;

const getDataState = createSelector(
  getState,
  state => state.data
);

const getDataEntities = createSelector(
  getDataState,
  state => state.entities
);

export const getUIState = createSelector(
  getState,
  state => state.ui
);

export const getContactListById = createSelector(
  getDataEntities,
  getProps,
  (entities, contactListId) => entities[contactListId]
);

export const canExportContactList = createSelector(
  getContactListById,
  contactList => contactList?.status === CONTACT_LIST_STATUS_ENUM.ACTIVE
);

export const isReadonlyContactList = createSelector(
  getCurrentUserIsReadOnly,
  getContactListById,
  (isReadonly, contactList) => isReadonly || contactList?.status !== CONTACT_LIST_STATUS_ENUM.ACTIVE
);

export const getContactListsByIds = createSelector(
  getDataEntities,
  getProps,
  (entities, ids = []) => ids.reduce((acc, contactListId) => {
    const entity = entities[contactListId];
    if (entity) {
      return [...acc, entity];
    }
    return acc;
  }, [])
);

const getSelectsSlice = createSelector(
  getUIState,
  state => state.selects,
);

export const getSelectSlice = createSelector(
  getSelectsSlice,
  getProps,
  (selects, token) => selects[token] ?? {}
);

const getSelectIds = createSelector(
  getSelectSlice,
  select => select?.ids
);

export const getSelectEntities = createSelector(
  getRoot,
  getSelectIds,
  getContactListsByIds,
);
